export default "__VITE_ASSET__CZQ2fYVy__";